/**
 * @generated SignedSource<<550c3e82f5306d696c8ee96988a77cb1>>
 * @relayHash 645755f269992aa280c50df84ede4be6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5c9ba59756316e1ee64f1543626c9781e9bdc074e90056f11cf2c1ae0ed92f25

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraDeleteVersionWithNoIssuesInput = {
  id: string;
};
export type actions_deleteVersionWithNoIssuesMutation$variables = {
  input: JiraDeleteVersionWithNoIssuesInput;
};
export type actions_deleteVersionWithNoIssuesMutation$data = {
  readonly jira: {
    readonly deleteJiraVersionWithNoIssues: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type actions_deleteVersionWithNoIssuesMutation = {
  response: actions_deleteVersionWithNoIssuesMutation$data;
  variables: actions_deleteVersionWithNoIssuesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraUpdateVersionPayload",
        "kind": "LinkedField",
        "name": "deleteJiraVersionWithNoIssues",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "actions_deleteVersionWithNoIssuesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "actions_deleteVersionWithNoIssuesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5c9ba59756316e1ee64f1543626c9781e9bdc074e90056f11cf2c1ae0ed92f25",
    "metadata": {},
    "name": "actions_deleteVersionWithNoIssuesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b81aa40061fe9aaae97b566e66bb6164";

export default node;
